//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import echarts from 'echarts';
import { aiStatisticsOverviewApi, aiStatisticsUserRankingApi, aiStatisticsUserListApi } from '@/api/aiStatistics';
import ChatRecordDialog from './components/chatRecordDialog';
import UserDetailDrawer from './components/userDetailDrawer';
var CHART_COLORS = {
  token: '#1890ff',
  activity: '#52c41a',
  market: '#faad14',
  apply: '#eb2f96'
};
export default {
  name: 'AiStatistics',
  components: {
    ChatRecordDialog: ChatRecordDialog,
    UserDetailDrawer: UserDetailDrawer
  },
  data: function data() {
    return {
      timeVal: [],
      keyword: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      tableFrom: {
        startTime: '',
        endTime: '',
        keyword: '',
        page: 1,
        limit: 10
      },
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      rankingLoading: false,
      rankingLimit: 10,
      rankingList: [],
      rankingTotalTokens: 0,
      overviewLoading: false,
      overview: {
        totalTokens: 0,
        inputTokens: 0,
        outputTokens: 0,
        cachedInputTokens: 0,
        uncachedInputTokens: 0,
        userCount: 0,
        conversationCount: 0,
        messageCount: 0,
        activityCreateCount: 0,
        marketCreateCount: 0,
        activityApplyCount: 0
      },
      trendList: [],
      chart: null,
      chatVisible: false,
      detailVisible: false,
      currentUser: {
        uid: null,
        nickname: ''
      }
    };
  },
  computed: {
    overviewCards: function overviewCards() {
      var o = this.overview;
      return [{
        key: 'token',
        title: 'token 总消耗',
        value: o.totalTokens,
        unit: '',
        icon: 'el-icon-coin',
        color: CHART_COLORS.token,
        extra: "\u8F93\u5165 ".concat(this.formatNumber(o.inputTokens), "\uFF08\u7F13\u5B58\u547D\u4E2D ").concat(this.formatNumber(o.cachedInputTokens), "\uFF09\xB7 \u8F93\u51FA ").concat(this.formatNumber(o.outputTokens))
      }, {
        key: 'activity',
        title: 'AI 活动创建数',
        value: o.activityCreateCount,
        unit: ' 个',
        icon: 'el-icon-date',
        color: CHART_COLORS.activity,
        extra: "AI \u4F1A\u8BDD ".concat(this.formatNumber(o.conversationCount), " \u4E2A \xB7 \u6D88\u606F ").concat(this.formatNumber(o.messageCount), " \u6761")
      }, {
        key: 'market',
        title: 'AI 集市创建数',
        value: o.marketCreateCount,
        unit: ' 个',
        icon: 'el-icon-office-building',
        color: CHART_COLORS.market,
        extra: "\u6D88\u8017\u7528\u6237 ".concat(this.formatNumber(o.userCount), " \u4EBA")
      }, {
        key: 'apply',
        title: 'AI 活动报名数',
        value: o.activityApplyCount,
        unit: ' 次',
        icon: 'el-icon-tickets',
        color: CHART_COLORS.apply,
        extra: '通过 AI 助手确认报名的次数'
      }];
    },
    rangeText: function rangeText() {
      var _this$tableFrom = this.tableFrom,
        startTime = _this$tableFrom.startTime,
        endTime = _this$tableFrom.endTime;
      if (!startTime && !endTime) return '全部时间';
      return "".concat(startTime || '不限', " \u81F3 ").concat(endTime || '不限');
    }
  },
  mounted: function mounted() {
    this.initChart();
    this.loadAll();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    initChart: function initChart() {
      if (!this.$refs.trendChart) return;
      this.chart = echarts.init(this.$refs.trendChart);
      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart: function resizeChart() {
      if (this.chart) this.chart.resize();
    },
    buildParams: function buildParams(extra) {
      return Object.assign({
        startTime: this.tableFrom.startTime,
        endTime: this.tableFrom.endTime
      }, extra || {});
    },
    loadAll: function loadAll() {
      this.getOverview();
      this.getRanking();
      this.getList();
    },
    // 总览
    getOverview: function getOverview() {
      var _this = this;
      this.overviewLoading = true;
      aiStatisticsOverviewApi(this.buildParams()).then(function (res) {
        var data = res || {};
        _this.overview = {
          totalTokens: data.totalTokens || 0,
          inputTokens: data.inputTokens || 0,
          outputTokens: data.outputTokens || 0,
          cachedInputTokens: data.cachedInputTokens || 0,
          uncachedInputTokens: data.uncachedInputTokens || 0,
          userCount: data.userCount || 0,
          conversationCount: data.conversationCount || 0,
          messageCount: data.messageCount || 0,
          activityCreateCount: data.activityCreateCount || 0,
          marketCreateCount: data.marketCreateCount || 0,
          activityApplyCount: data.activityApplyCount || 0
        };
        _this.trendList = data.trend || [];
        _this.overviewLoading = false;
        _this.renderChart();
      }).catch(function () {
        _this.overviewLoading = false;
      });
    },
    // 排名
    getRanking: function getRanking() {
      var _this2 = this;
      this.rankingLoading = true;
      aiStatisticsUserRankingApi(this.buildParams({
        top: this.rankingLimit
      })).then(function (res) {
        _this2.rankingList = res || [];
        _this2.rankingTotalTokens = _this2.rankingList.reduce(function (sum, item) {
          return sum + Number(item.rangeTokens || 0);
        }, 0);
        _this2.rankingLoading = false;
      }).catch(function () {
        _this2.rankingLoading = false;
      });
    },
    // 用户统计
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      aiStatisticsUserListApi(Object.assign({}, this.tableFrom, {
        page: this.tableFrom.page,
        limit: this.tableFrom.limit
      })).then(function (res) {
        _this3.tableData.data = res && res.list || [];
        _this3.tableData.total = res && res.total || 0;
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    handleTimeChange: function handleTimeChange(val) {
      this.timeVal = val || [];
      this.tableFrom.startTime = this.timeVal && this.timeVal.length ? this.timeVal[0] : '';
      this.tableFrom.endTime = this.timeVal && this.timeVal.length ? this.timeVal[1] : '';
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      this.tableFrom.page = 1;
      this.tableFrom.keyword = this.keyword;
      this.loadAll();
    },
    handleReset: function handleReset() {
      this.timeVal = [];
      this.keyword = '';
      this.tableFrom = {
        startTime: '',
        endTime: '',
        keyword: '',
        page: 1,
        limit: this.tableFrom.limit
      };
      this.loadAll();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.tableFrom.limit = limit;
      this.tableFrom.page = 1;
      this.getList();
    },
    openDetail: function openDetail(row) {
      this.currentUser = {
        uid: row.uid,
        nickname: row.nickname || ''
      };
      this.detailVisible = true;
    },
    openChat: function openChat(row) {
      this.currentUser = {
        uid: row.uid,
        nickname: row.nickname || ''
      };
      this.chatVisible = true;
    },
    // 图表
    renderChart: function renderChart() {
      if (!this.chart) {
        this.initChart();
      }
      if (!this.chart) return;
      var trend = this.trendList || [];
      if (trend.length === 0) {
        this.chart.clear();
        return;
      }
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: ['token消耗', '创建活动', '创建集市', '活动报名'],
          top: 0,
          right: 10
        },
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 40
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: trend.map(function (item) {
            return item.date;
          }),
          axisLabel: {
            fontSize: 11,
            color: '#666'
          }
        },
        yAxis: [{
          type: 'value',
          name: 'token',
          nameTextStyle: {
            fontSize: 11,
            color: '#999'
          },
          axisLabel: {
            fontSize: 11,
            color: '#666'
          },
          splitLine: {
            lineStyle: {
              color: '#f0f0f0'
            }
          }
        }, {
          type: 'value',
          name: '次数',
          minInterval: 1,
          nameTextStyle: {
            fontSize: 11,
            color: '#999'
          },
          axisLabel: {
            fontSize: 11,
            color: '#666'
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: 'token消耗',
          type: 'line',
          smooth: true,
          yAxisIndex: 0,
          symbolSize: 6,
          data: trend.map(function (item) {
            return item.tokens || 0;
          }),
          itemStyle: {
            color: CHART_COLORS.token
          },
          areaStyle: {
            color: 'rgba(24,144,255,0.12)'
          }
        }, {
          name: '创建活动',
          type: 'bar',
          yAxisIndex: 1,
          barMaxWidth: 14,
          data: trend.map(function (item) {
            return item.activityCreateCount || 0;
          }),
          itemStyle: {
            color: CHART_COLORS.activity
          }
        }, {
          name: '创建集市',
          type: 'bar',
          yAxisIndex: 1,
          barMaxWidth: 14,
          data: trend.map(function (item) {
            return item.marketCreateCount || 0;
          }),
          itemStyle: {
            color: CHART_COLORS.market
          }
        }, {
          name: '活动报名',
          type: 'bar',
          yAxisIndex: 1,
          barMaxWidth: 14,
          data: trend.map(function (item) {
            return item.activityApplyCount || 0;
          }),
          itemStyle: {
            color: CHART_COLORS.apply
          }
        }]
      }, true);
    },
    rankingRatio: function rankingRatio(row) {
      var total = this.rankingTotalTokens;
      if (!total) return 0;
      var value = Number(row.rangeTokens || 0);
      return Math.min(100, Math.round(value / total * 1000) / 10);
    },
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0';
      var num = Number(value);
      if (isNaN(num)) return String(value);
      return num.toLocaleString('zh-CN');
    }
  }
};